import React from "react";

import { SubBar, MainView } from "lib/index";

export default class RaportsView extends React.PureComponent {
  render() {
    return (
      <MainView.Container>
        <MainView.Content grayBackground hasSubBar>
          <MainView.Dimmer
            placeholderTitle="Raporty"
            placeholderMessage={
              <div>
                <p>
                  Już niedługo w tym miejscu będziesz miał możliwość przeglądania zaawansowanych statystyk dotyczących
                  Twojej firmy.
                </p>
                <p>Pomoże to Tobie podejmować w przyszłości lepsze decyzje w kluczowych aspektach Twojego biznesu.</p>
              </div>
            }
            placeholderIcon="show_chart"
          />
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/raports/RaportsView.jsx